import {LauncherServiceBase} from '../launcher-service-base';
import {ILauncherServiceFactory} from '../launcher-service-factory.interface';
import {action, observable} from 'mobx';
import {IRoute} from '../../../app-react/services/routing/route/route.interface';
import {tryMatchPath} from '../../../app-react/services/routing/routing-utils';
import {Uri} from '../../../app-react/services/location/uri/uri';
import {FallbackRoute} from '../../../app-react/services/routing/route/fallback-route';
import {buildLauncherPath, LAUNCHER_ROUTING_CONFIGURATION} from './launcher-routing-configuration';
import {LauncherRoute} from './launcher-route';
import {ILauncherRoutingService} from './launcher-routing.service.interface';
import {UriPath} from '../../../app-react/services/location/uri-path/uri-path';

export class LauncherRoutingService extends LauncherServiceBase implements ILauncherRoutingService {
    constructor(services: ILauncherServiceFactory) {
        super(services);

        this.reaction(() => this.services.location.currentUri,
            (uri) => this._updateCurrentRoute(uri),
            {
                fireImmediately: true
            });
    }

    @observable.ref currentRoute: IRoute;

    @action.bound
    private _updateCurrentRoute(uri: Uri): void {

        let match = tryMatchPath(uri.pathName.toString(), LAUNCHER_ROUTING_CONFIGURATION.routes);

        if(match) {
            this.currentRoute = new LauncherRoute(match.routeDefinition, match.routeParams);
        } else {
            this.currentRoute = new FallbackRoute(LAUNCHER_ROUTING_CONFIGURATION.fallbackRoute.render);
        }
    }

    navigate(path: UriPath | string): void {
        this.services.location.push(buildLauncherPath(path).toString())
    }

    goHome(): void {
        this.services.location.push(buildLauncherPath('').toString());
    }

}